// Lists rendered inside the user settings modal. The modal surface
// (bg-modal-background) is lighter than the default dark border token, so
// these lists use the dialog's stronger dark border and divider, like the
// dialog's own sidebar and footer separators.
export const MODAL_SETTINGS_LIST_CLASSES =
  "dark:border-border-dark dark:divide-border-dark";
